function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 5C9.477 5 5 9.477 5 15s4.477 10 10 10 10-4.477 10-10S20.523 5 15 5zM7 15a8 8 0 1116 0 8 8 0 01-16 0z",
  fill: "currentColor"
});
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 4,
  fill: "currentColor"
});
function SvgSelectedRadio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _ref, _ref2);
}
export default __webpack_public_path__ + "fonts/selected-radio-144c9b0ce669c73effb8167908bfbbef.svg";
export { SvgSelectedRadio as ReactComponent };